<template>
	<div class="credentials__wrapper">
		<div class="form__error" v-if="errors.global">{{errors.global}}</div>
		<div class="login__row">
			<img src="@/assets/svg/phone.svg" alt />
			<input
				type="text"
				name="login"
				autocomplete="email"
				@blur="checkLogin"
				@keypress.enter="handleSubmit"
				v-model="login"
				placeholder="Login (adres e-mail)"
			/>
			<div v-if="errors.login" class="form__row-error form__row-error--icon">{{errors.login}}</div>
		</div>
		<div class="login__row">
			<img src="@/assets/svg/lock.svg" alt />
			<input
				type="password"
				name="password"
				autocomplete="current-password"
				@blur="checkPassword"
				@keypress.enter="handleSubmit"
				v-model="password"
				placeholder="Hasło"
			/>
			<div v-if="errors.password" class="form__row-error form__row-error--icon">{{errors.password}}</div>
		</div>
		<div class="login__row">
			<a :class="submitBtnClass" @click="handleSubmit">Zaloguj się</a>
		</div>
		<div class="login__row login-actions">
			<div class="login-actions__item">
				Nie masz konta?
				<router-link to="/rejestracja" class="login-actions__link">Zarejestruj się</router-link>
			</div>
			<div class="login-actions__item">
				Nie pamiętasz hasła?
				<a @click="$emit('nextStep', 'resetPassword')" class="login-actions__link">Zresetuj hasło</a>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: "Credentials",
	data() {
		return {
			errors: {
				login: '',
				password: '',
				global: ''
			},
			submitBtnClass: 'btn',
			login: '',
			password: '',
		};
	},
	methods: {
		checkLogin() {
			this.errors.login = "";
			if (!this.login) {
				this.errors.login = "Login jest wymagany"
			} else if (!this.validEmail(this.login)) {
				this.errors.login = "Podaj prawidłowy adres e-mail"
			}
		},
		checkPassword() {
			this.errors.password = "";
			!this.password ? (this.errors.password = "Hasło jest wymagane") : null;
		},

		handleSubmit() {
			const { login, password } = this;
			this.errors.global = '';

			this.checkLogin();
			this.checkPassword();

			if (this.validEmail(login) && password) {
				this.submitBtnClass = "btn spinner spinner--running";
				axios({
					method: 'post',
					url: `${process.env.VUE_APP_API_URL}/login/send-code`,
					headers: {
						'Content-type': "application/json"
					},
					data: {
						username: login,
						password: password
					}
				}).then( (response) => {
					this.submitBtnClass = "btn spinner spinner--complete";
					this.$store.commit("saveLoginData", {
						id: response.data.id
					});
					setTimeout(() => this.$emit("nextStep", "code"), 1000);
				}).catch( (err) => {
					this.submitBtnClass = "btn";
					this.errors.global = err.response.data.message ? err.response.data.message : "Wystąpił nieznany błąd";
				});

			} else {
				this.errors.global = "Błąd walidacji formularza.";
			}
		},
		validEmail(email) {
			var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		}
	}
};
</script>

<style lang="scss">
.credentials {
	&__wrapper {
		width: 95%;
		max-width: 360px;
		margin: 30px auto;
		text-align: center;
	}
}
</style>
